import { combineReducers } from "redux";

import { TaskType } from "../task/model";

import {
    BookAppointmentTaskListModel,
    BookAppointmentsState,
    BookAppointmentErrors,
    CalendarFiltersState,
    ChooseAndBookStatus,
    BookAppointmentTaskListModelData
} from "./models";
import { BookAppointmentAction } from "./actions";

import * as actions from "./actionTypes";

const bookAppointmentTasks = (state: BookAppointmentTaskListModel[] = [], action: BookAppointmentAction): BookAppointmentTaskListModel[] => {
    switch (action.type) {
        case actions.LOAD_BOOK_APPOINTMENT_TASKS_SUCCESS:
            return action.payload;
        case actions.BOOK_INTO_CLINIC_STARTED:
        case actions.BOOK_AD_HOC_APPOINTMENT_SUCCESS:
            return state.filter(t => t.id !== action.payload.bookTask.id);
        case actions.BOOK_INTO_CLINIC_ERROR:
            return [ action.payload.bookTask, ...state ];
        case actions.REQUEST_CHOOSE_AND_BOOK_SUCCESS:
        case actions.ADD_BOOKING_NOTES_SUCCESS:
            return state.map(t => bookAppointmentTask(t, action));
        default:
            return state;
    }
};

const bookAppointmentTasksData = (state: BookAppointmentTaskListModelData = null, action: BookAppointmentAction): BookAppointmentTaskListModelData => {
    switch (action.type) {
        case actions.LOAD_BOOK_APPOINTMENT_TASKS_DATA:
            return action.payload;
        default:
            return state;
    }
};

const bookAppointmentTask = (state: BookAppointmentTaskListModel, action: BookAppointmentAction): BookAppointmentTaskListModel => {
    switch (action.type) {
        case actions.REQUEST_CHOOSE_AND_BOOK_SUCCESS:
            if (state.id === action.payload) {
                return { ...state, chooseAndBookStatus: ChooseAndBookStatus.Requested };
            }

            return state;
        case actions.ADD_BOOKING_NOTES_SUCCESS:
            if (state.id === action.payload.taskId) {
                return { ...state, notes: action.payload.notes };
            }
            return state;
        default:
            return state;
    }
};

const bookAppointmentTaskTypes = (state: TaskType[] = [], action: BookAppointmentAction): TaskType[] => {
    switch (action.type) {
        case actions.LOAD_BOOK_APPOINTMENT_TASK_TYPES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

const bookAppointmentErrors = (state: BookAppointmentErrors = null, action: BookAppointmentAction): BookAppointmentErrors => {
    switch (action.type) {
        case actions.BOOK_AD_HOC_APPOINTMENT_ERROR:
            return action.payload;
        case actions.BOOK_AD_HOC_APPOINTMENT_STARTED:
        case actions.BOOK_INTO_CLINIC_STARTED:
            return { userClashIds: [] };
        case actions.BOOK_INTO_CLINIC_ERROR:
            return { userClashIds: [], appointmentClash: true };
        default:
            return state;
    }
};

const calendarFilters = (state: CalendarFiltersState = {}, action: BookAppointmentAction): CalendarFiltersState => {
    switch (action.type) {
        case actions.SHOW_ONLY_CLINICS_WITH_INSUFFICIENT_CLINICIANS_CHANGED:
            return { ...state, showOnlyClinicsWithInsufficientClinicians: action.payload };
        case actions.CLINIC_TYPE_CHANGED:
            return { ...state, clinicType: action.payload };
        case actions.CLINIC_LOCATION_TYPE_CHANGED:
            return { ...state, clinicLocationType: action.payload };
        case actions.DATE_CHANGED:
            return { ...state, focusDate: action.payload };
        case actions.SELECTED_USER_IDS_CHANGED:
            return { ...state, selectedUserIds: action.payload };
        case actions.SELECTED_ROOM_IDS_CHANGED:
            return { ...state, selectedRoomIds: action.payload };
        default:
            return state;
    }
};

export const bookAppointments = combineReducers<BookAppointmentsState>({
    bookAppointmentTasks,
    bookAppointmentTaskTypes,
    bookAppointmentErrors,
    calendarFilters,
    bookAppointmentTasksData
});
